// frontend/src/components/Layout/Layout.jsx
import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { ToastContainer } from "../../context/ToastContext";
import AIChatWidget from "../AI/AIChatWidget";
import "./layout.scss";

const Layout = ({ children }) => {
  return (
    <div className="app-layout">
      <Navbar />
      <main className="main-content">{children}</main>
      <Footer />
      <ToastContainer />
      <AIChatWidget clientId="kenali-enterprise" />
    </div>
  );
};

export default Layout;